import { $authHost } from './index'
import { httpPoint } from '../utils/const'

export const getResultSearch = async ( query, rout ) => {
    if( localStorage.getItem('token') ){
        
        try{
            const {data} = await $authHost.post(httpPoint.search + 'find', { query, rout } )
            return data
        } catch(e){
            throw e;
        }

    }
}

